/**
 * Barrel for the CRM API contracts.
 *
 * Routes (server) import via `@excellent/ui/api/contracts/crm` and call
 * `createRoute(crm.leads.list, ...)`. Clients import the same way and call
 * `apiCall(crm.leads.list, args)` or `useApi(crm.leads.list, args)`.
 */

export { leads } from "./leads";
export { opportunities } from "./opportunities";
export { pipelines } from "./pipelines";
export { calls, emails, sms, meetings } from "./communications";
export { sequences } from "./sequences";
export { templates } from "./templates";
export { smart_views, smartViewQuerySchema } from "./smart_views";
export { settings } from "./settings";
export { reports } from "./reports";
export { seed } from "./seed";
// The `_crm/*View` read contracts (RO-3-00d / #44471) — the vault reads the
// Next server components did inline, moved behind ops so the views can run in
// the browser host. See ./views.ts for what is deliberately NOT here.
export {
  views,
  type CrmAccountRow,
  type CrmAccountsResponse,
  type CrmContactRow,
  type CrmContactsResponse,
  type CrmOpenDealRow,
  type CrmForecastResponse,
  type CrmRenewalResponse,
  type CrmSequenceViewRow,
  type CrmSequencesViewResponse,
  type CrmLeadsViewResponse,
  type CrmSupportViewResponse,
} from "./views";

// Re-export shared row schemas for clients that want runtime validation.
export {
  crmLeadRowSchema,
  crmOpportunityRowSchema,
  crmIdParams,
} from "./_shared";

import { leads } from "./leads";
import { opportunities } from "./opportunities";
import { pipelines } from "./pipelines";
import { calls, emails, sms, meetings } from "./communications";
import { sequences } from "./sequences";
import { templates } from "./templates";
import { smart_views } from "./smart_views";
import { settings } from "./settings";
import { reports } from "./reports";
import { seed } from "./seed";
import { views } from "./views";

/** Aggregate, mirroring the Lens `lens.*` shape. */
export const crm = {
  leads,
  opportunities,
  pipelines,
  calls,
  emails,
  sms,
  meetings,
  sequences,
  templates,
  smart_views,
  settings,
  reports,
  seed,
  views,
};
